import React from 'react';
import { Phone, Mail } from 'lucide-react';

export function ContactInfo() {
  return (
    <div className="space-y-4 text-gray-400">
      <div className="flex items-center gap-2">
        <Phone className="w-5 h-5 text-green-500" />
        <span>+1 (705) 307-6659</span>
      </div>
      <div className="flex items-center gap-2">
        <Mail className="w-5 h-5 text-green-500" />
        <span>priorityai.info@gmail.com</span>
      </div>
    </div>
  );
}